import React from 'react'
import {AppointmentHandler} from "../../components/index"

const Appointment = () => {







  return (
    <div>
      <AppointmentHandler/>
    </div>
  )
}

export default Appointment
